import { colors, createMuiTheme, responsiveFontSizes } from "@material-ui/core";
import merge from "lodash/merge";
import palette from "./palette";
import { softShadows } from "./shadows";
import typography from "./typography";
const baseOptions = {
    typography,
    palette,
    shadows: softShadows,
};
const themeOptions = {
    props: {
        MuiSelect: {
            variant: "outlined",
        },
        MuiTextField: {
            variant: "outlined",
        },
        MuiFormControl: {
            variant: "outlined",
        },
    },
    overrides: {
        MuiInputBase: {
            input: {
                "&::placeholder": {
                    opacity: 1,
                    color: colors.blueGrey[600],
                },
            },
        },
        MuiLinearProgress: {
            root: {
                borderRadius: 3,
                overflow: "hidden",
            },
        },
        MuiListItemIcon: {
            root: {
                minWidth: 32,
            },
        },
        MuiChip: {
            root: {
                backgroundColor: "rgba(0,0,0,0.075)",
            },
        },
    },
};
const createTheme = (config = {}) => {
    const { customOverrides } = config;
    let theme = createMuiTheme(merge({}, baseOptions, themeOptions, customOverrides));
    if (config.responsiveFontSizes) {
        theme = responsiveFontSizes(theme);
    }
    return theme;
};
export default createTheme;
//# sourceMappingURL=index.js.map